import React, { Component } from 'react';
import Modal from "../../../components/Modal/";

import './add-students-flow.less';
import trackEvent from "../eventTracking";


class SelectGoogleClassroomCourseModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      courses: props.courseMap || {},
      courseId: Object.keys(props.courseMap)[0] || -1
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.open && !(prevProps.open)) {
      this.setState({
        courses: this.props.courseMap,
        courseId: Object.keys(this.props.courseMap)[0]
      })
    }
  }

  /////////////////////////////////
  // Helper functions
  /////////////////////////////////

  getOptionElement = (courseId, courseName) => {
    return (
      <option
        key={courseId}
        value={courseId}
      >
        {courseName}
      </option>
    )
  }

  handleChange = (e) => {
    this.setState({
      courseId: e.target.value
    });
  }

  handleSubmit = () => {
    trackEvent('import names', 'completed', true, 'google classroom');

    this.props.handleSubmit(this.state.courseId);
  }

  /////////////////////////////////

  render() {
    return (
      <Modal className='select-a-gcourse-modal' open={this.props.open} onClose={this.props.closeSelectGoogleClassroomCourseModal}>
        <h3>Select a course</h3>

        <div className='form'>
          <div className="input-row">
            <label className="floating">
              <select
                value={this.state.courseId}
                onChange={(e) => {this.handleChange(e)}}
              >
                <option></option>
                {Object.keys(this.state.courses).map((courseId) => {return this.getOptionElement(courseId, this.state.courses[courseId])})}
              </select>
            </label>
          </div>
        </div>

        <div className="bottom-buttons">
          <button
            className="btn btn-secondary"
            onClick={this.props.closeSelectGoogleClassroomCourseModal}
          >
            Cancel
          </button>

          <button
            className={"btn btn-primary"}
            onClick={() => this.handleSubmit()}
          >
            Import<span className="hide-if-mobile"> names from this course</span>
          </button>
        </div>
      </Modal>
    )
  }
}

export default SelectGoogleClassroomCourseModal;
